module.exports = __webpack_public_path__ + "media/images/phone-call-icon-323ed0cad02409e023292ee75d2cb736.png";